import { render, staticRenderFns } from "./ChartJSBarChart.vue?vue&type=template&id=4e50a1a4&scoped=true"
import script from "./ChartJSBarChart.vue?vue&type=script&lang=js"
export * from "./ChartJSBarChart.vue?vue&type=script&lang=js"
import style0 from "./ChartJSBarChart.vue?vue&type=style&index=0&id=4e50a1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50a1a4",
  null
  
)

export default component.exports